import { customAnalyticsApi } from '../apis';

import type { AxiosResponse } from 'axios';
import type { CustomAnalytic } from '../core/types/analytic.types';

export const getCustomAnalytic = async (
  customAnalyticsId: string
): Promise<AxiosResponse<CustomAnalytic>> =>
  customAnalyticsApi.get<CustomAnalytic>(`analytics/${customAnalyticsId}`);
